const workLogRoute = {
  path: 'work-log',
  name: 'workLog',
  component: { template: '<router-view></router-view>' },
  children: [{
    path: 'list',
    name: 'workLogList',
    component: () => import('./index.vue'),
    meta: { navtabTitle: '工作日志管理', isCache: true, ignoreDiff: [], isIframe: false }
  }]
};

export default workLogRoute;
